<mat-dialog-content>
  <div class="ai-chatbot-header">
    <div class="ai-chatbot-header-left">
      <img
        class="ai-chatbot-avatar"
        src="/images/ai-chatbot/ai-chatbot-pixel-avatar.png"
        title="Pixel avatar"
      />
      <div class="ai-chatbot-header-text">
        <span class="ai-chatbot-header-text-title">Pixel</span>
        <span class="ai-chatbot-header-text-subtitle"
          >Generate Presentations</span
        >
      </div>
    </div>
    <div class="ai-chatbot-header-right">
      <button
        mat-stroked-button
        class="ai-chatbot-header-restart-button"
        (click)="restartSession()"
        tabindex="0"
      >
        Restart Chat
      </button>
      <button
        mat-icon-button
        aria-label="Close AI chatbot"
        class="ai-chatbot-header-close-button small-icon-button"
        (click)="close()"
        tabindex="0"
      >
        <mat-icon class="bold" svgIcon="close"></mat-icon>
      </button>
    </div>
  </div>

  <div class="ai-chatbot-chat" #chatContainer>
    <div class="ai-chatbot-chat-first-message">
      <div
        class="ai-chatbot-chat-first-message-part"
        *ngFor="let messagePart of aiChatbotService.firstMessagesShownParts"
        [@slideInUp]="aiChatbotService.firstMessageIsRendering"
        [innerHTML]="messagePart"
      ></div>
    </div>

    <ai-chatbot-message
      *ngFor="
        let message of aiChatbotService.currentSession?.messages$ | async;
        last as isLast
      "
      [message]="message"
      [isLastMessage]="isLast"
      (selectedTemplateIdxChange)="selectedTemplateIdx=$event"
    ></ai-chatbot-message>

    <ai-chatbot-loading
      *ngIf="aiChatbotService.isProcessing || aiChatbotService.isLoadingTemplates"
    ></ai-chatbot-loading>
  </div>

  <ai-chatbot-prompt-box
    [initialPrompt]="initialPrompt"
  ></ai-chatbot-prompt-box>
</mat-dialog-content>
